import { RESET_STATE } from 'store/global/actions';

import { UW_REPORTS_ACTION_TYPE } from '../actions';

const initialState = {};

const uwReportsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UW_REPORTS_ACTION_TYPE.GET_UW_REPORTS_BY_LOAN_ID:
      return payload || state;

    case UW_REPORTS_ACTION_TYPE.GET_UW_REPORT_BY_REPORT_ID:
    case UW_REPORTS_ACTION_TYPE.GENERATE_NEW_UW_REPORT:
      return { ...state, [payload.reportId]: payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default uwReportsReducer;
